import { apiClient, createSuccessResponse, handleApiError } from "../api";


const authService = {

    /**
     * @function forgotPassword
     * @description Solicita o envio de email para recuperação de senha
     * @param {string} login - Login do usuário (email ou username)
     * @returns {Promise<Object>} - Resposta da API
     */
    async forgotPassword(login) {
        try {
            const retorno = await apiClient.post('/auth/forgot-password', {
                login: login,
                redirectUrl: process.env.REACT_APP_REDIRECT_URL
            });

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            };
        }
    },

    /**
     * @function validateResetToken
     * @description Valida o token de reset de senha recebido por email
     * @param {string} token - Token de reset de senha
     * @returns {Promise<Object>} - Resposta da API
     */
    async validateResetToken(token) {
        try {
            const retorno = await apiClient.get('/auth/validate-reset-token', {
                params: {
                    token: token
                }
            });

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            };
        }
    },

    /**
     * @function resetPassword
     * @description Redefine a senha do usuário usando o token de reset
     * @param {string} token - Token de reset de senha
     * @param {string} newPassword - Nova senha
     * @returns {Promise<Object>} - Resposta da API
     */
    async resetPassword(token, newPassword) {
        try {
            const retorno = await apiClient.post('/auth/reset-password', {
                token: token,
                newPassword: newPassword
            });

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            };
        }
    },

    /**
     * @function changePassword
     * @description Altera a senha do usuário autenticado
     * @param {string} newPassword - Nova senha
     * @returns {Promise<Object>} - Resposta da API
     */
    async changePassword(newPassword) {
        try {
            const retorno = await apiClient.post('/auth/change-password', {
                newPassword: newPassword
            });

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            };
        }
    }
}

export default authService;
